export default function(category) {
	return {
		methods: {
			trackSlider(slider) {
				this.$gtag.event('Slider', {
					event_category: category,
					event_label: slider.title,
					value: slider.count
				})
			}
		}
	}
}
